import * as React from 'react';
import {Dropzone} from 'components/Dropzone';
import {FormShell} from 'components/form/FormShell';
import {FileContainer} from 'components/ui/FileContainer';
import {observer} from 'mobx-react-lite';
import {VehicleState} from 'store/vehicle/VehicleState';

interface VehicleFilesProps {
  state: VehicleState;
}

export const VehicleFiles: React.FunctionComponent<VehicleFilesProps> = observer(({state}): JSX.Element => {
  return (
    <FormShell isLoading={state.isLoading}>
      <div>
        <Dropzone multiple={true} onDrop={(acceptedFiles: File[]) => state.updateAttachments(acceptedFiles)} />
        <div className="grid grid-cols-1 md:grid-cols-2 mt-4 gap-x-4 gap-y-2">
          {state.item.attachments?.attachments?.map((file) => (
            <FileContainer key={file.fileId} file={file} onRemove={() => state.removeAttachment(file.fileId)} />
          ))}
        </div>
      </div>
    </FormShell>
  );
});
